<script lang="ts">
interface Props extends ButtonProps, RouterProps, ComposableTooltipProps {}

/** @deprecated use <Button /> instead */
export default {};
</script>

<script setup lang="ts">
import { useForwardProps } from "reka-ui";
import { h, useAttrs, useSlots } from "vue";
import { type RouterProps } from "../../composables/router";
import { useTooltip, type ComposableTooltipProps } from "../../composables/tooltip";
import Button, { type ButtonProps } from "./Button.vue";
import LinkButton from "./LinkButton.vue";

const props = defineProps<Props>();
const forwardedProps = useForwardProps(props);
const emit = defineEmits<{
	(evt: "click", e: MouseEvent): void;
}>();

const { renderWithTooltip } = useTooltip(props);

const slots = useSlots();
const attrs = useAttrs();

function render() {
	let component: any = Button;
	if (props.to != null) {
		component = LinkButton;
	}

	const button = h(
		component,
		{
			...forwardedProps.value,
			...attrs,
			onClick: (e) => emit("click", e),
		},
		() => slots.default?.()
	);

	return renderWithTooltip(button);
}
</script>

<template>
	<component :is="render" />
</template>
